<template>
  <main class="mt-3">
    <div class="container">
      <h2 class="text-center"><u>상품이미지등록</u></h2>
      <div class="mb-3 row">
        <!-- 수정불가 -->
        <label class="col-md-3 col-form-label">상품코드</label>
        <div class="col-md-9 text-primary">
          <!-- <input type="text" class="form-control" readonly> -->
          {{ productId }}
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">상품명<font class="text-secondary" style="font-size: small;">(국문)</font></label>
        <div class="col-md-9 text-primary">
          <!-- <input type="text" class="form-control" readonly> -->
          {{ productInfo.pdtNameKor }}
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">상품Thumbnail</label>
        <div class="col-md-9">
          <!-- <input class="form-control" type="file" accept="image/png, image/jpg, image/jpeg"> -->
          <div class="form-control" type="file" accept="image/png, image/jpg, image/jpeg" :key="i" v-for="(m,i) in productImage.filter(c=>c.catImg=='T')">
            <div class="position-relative">
              <img :src="`/download/${productId}/${m.imgName}`" class="img-fluid" />
              <!-- <img :src="`/download/${productId}/${tImage}`" class="img-fluid" /> -->
              <div>
                <div class="position-absolute top-0 end-0" style="cursor:pointer;" @click="deleteImage(m.pdtCode, 'T', m.imgName)">
                  <i class="bi bi-trash3-fill text-danger fs-2 fw-bold"></i>
                </div>
                <!-- <p class="position-absolute top-0 end-70" style="cursor:pointer;" @click="sealingImage(m.pdtCode, 'T', m.imgName)">
                  <i class="bi bi-eye-slash text-warning"></i></p> -->
              </div>
            </div>
          </div>
          <input type="file" class="form-control" accept="image/png,image/jpeg" @change="uploadFile($event.target.files, 'T', '0')">  
          <div class="alert alert-secondary" role="alert" style="font-size:small;">
            <ul>
              <li>Image사이즈: 1:1 비율추천</li>
              <li>File 사이즈: 7M 이하</li>
              <li>File 확장자: png, jpeg, jpg</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 상품캐러셀 순번기능 추가(2026-10-26) -->
      <div class="mb-3 row">
          <label class="col-md-3 col-form-label">
            상품Images
            <div class="text-secondary" style="font-size: small; font-weight: normal;">(상세페이지 상단 캐러셀)</div>
          </label>
          <div class="col-md-9">

            <!-- 순서지정 바 -->
            <div class="carousel-order-bar" v-if="carouselImages.length > 1">
              <span class="carousel-order-guide">
                <i class="bi bi-info-circle"></i> ▲▼로 순서를 바꾼 뒤 [순서저장]을 눌러주세요. 1번이 첫 화면입니다.
              </span>
              <div class="d-flex gap-1">
                <button type="button" class="btn btn-sm btn-outline-secondary"
                        v-if="carouselDirty" :disabled="isSavingOrder" @click="getProductImage()">되돌리기</button>
                <button type="button" class="btn btn-sm btn-primary"
                        :disabled="!carouselDirty || isSavingOrder" @click="saveCarouselOrder()">
                  {{ isSavingOrder ? '저장중...' : '순서저장' }}
                </button>
              </div>
            </div>

            <div class="form-control mb-2" :key="m.imgName" v-for="(m, i) in carouselImages">
              <div class="position-relative">
                <img :src="`/download/${productId}/${m.imgName}`" class="img-fluid" />

                <!-- 순번 뱃지 -->
                <span class="carousel-order-badge" :class="{ first: i === 0 }">
                  {{ i + 1 }}<span v-if="i === 0"> · 대표</span>
                </span>

                <!-- 순서이동 버튼 -->
                <div class="carousel-move-group">
                  <button type="button" class="btn btn-sm btn-light" :disabled="i === 0 || isSavingOrder"
                          @click="moveCarousel(i, -1)" title="앞으로">
                    <i class="bi bi-caret-up-fill"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-light" :disabled="i === carouselImages.length - 1 || isSavingOrder"
                          @click="moveCarousel(i, 1)" title="뒤로">
                    <i class="bi bi-caret-down-fill"></i>
                  </button>
                </div>

                <!-- 삭제 -->
                <div class="position-absolute top-0 end-0" style="cursor:pointer;" @click="deleteImage(m.pdtCode, 'P', m.imgName)">
                  <i class="bi bi-trash3-fill text-danger fs-2 fw-bold"></i>
                </div>
              </div>
            </div>

            <input type="file" class="form-control" accept="image/png,image/jpeg" @change="uploadFile($event.target.files, 'P', '0')">
            <div class="alert alert-secondary" role="alert" style="font-size:small;">
              <ul>
                <li>등록가능: 5개 이하 추천</li>
                <li>Image사이즈: 640 * 450 추천</li>
                <li>File 사이즈: 3M 이하</li>
                <li>File 확장자: png, jpeg, jpg</li>
                <li>새로 올린 이미지는 맨 뒤에 붙습니다</li>
              </ul>
            </div>
          </div>
        </div>
      <div class="mb-3 row">
        <div class="col-3">
          <label>상품상세Image</label>
          <br>
          <button class="btn btn-success mt-2" v-if="this.quillFlag === 'Y'" @click="quillFlagging('N')">에디터닫기</button>
          <button class="btn btn-outline-success mt-2" v-else  @click="quillFlagging('Y')">에디터열기</button>
        </div>
        <div class="col-md-9">
          <!-- QuillEditor호출 -->
          <div v-if="this.quillFlag === 'Y'">
            <quill-editor v-model:content="content" :options="editorOption" @saveDocument="handleSaveDocument" />
          </div>
          
          <div v-else>
            <div class="form-control" type="file" accept="image/png, image/jpg, image/jpeg" :key="i" v-for="(m,i) in productImage.filter(c=>c.catImg=='D')">
              <div class="position-relative">
                <img :src="`/download/${productId}/${m.imgName}`" class="img-fluid" />
                <!-- <img :src="`/download/${productId}/${tImage}`" class="img-fluid" /> -->
                <div>
                  <div class="position-absolute top-0 end-0" style="cursor:pointer;" @click="deleteImage(m.pdtCode, 'D', m.imgName)">
                    <i class="bi bi-trash3-fill text-danger fs-2 fw-bold"></i>
                  </div>

                  <!-- 이미지순서지정 -->
                  <div class="position-absolute top-0 end-70">
                    <div class="input-group">
                      <input type="number" class="form-control-sm" style="width:70px; background-color: antiquewhite;" v-model="m.sort">
                      <button type="button" class="btn btn-sm btn-primary" style="font-size:smaller"  @click="locateImage(m.sort, m.pdtCode, 'D', m.imgName)">순서지정</button>
                    </div>
                  </div>

                  <!-- <p class="position-absolute top-0 end-70" style="cursor:pointer;" @click="sealingImage(m.pdtCode, 'D', m.imgName)">
                    <i class="bi bi-eye-slash text-warning"></i>
                  </p> -->
                </div>
              </div>
            </div>
            <input type="file" class="form-control" accept="image/png,image/jpeg" @change="uploadFile($event.target.files, 'D', '0')">  
            <div class="alert alert-secondary" role="alert" style="font-size:small;">
              <ul>
                <li>Image사이즈: 가로 1000px 이상</li>
                <li>File 사이즈: 5M 이하</li>
                <li>File 확장자: png, jpeg, jpg</li>
              </ul>
            </div>
          </div>
            </div>
        </div>
      <div class="mb-3 row">
        <!-- <div class="col-auto d-grid p-1">
          <button type="button" class="btn btn-lg btn-primary">저장</button>
        </div> -->
        <div class="col-auto d-grid p-1">
          <button type="button" class="btn btn-lg btn-danger" @click="goToList()">취소</button>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import QuillEditor from '@/components/QuillEditor.vue'
import axios from 'axios'

export default {
  components: { QuillEditor },

  data() {
    return {
      productInfo: {},                  //상품기본정보
      pdtFlag: "",
      productId: '',                    // 상품코드
      pdtNameKor: '',                   // 상품국문명
      //productDetail: {},              // 상세정보를 오브젝트형으로 변수처리
      productImage: [],
      productDetailImage: [],
      tImage: "",
      m: [],
      quillFlag: "N",

      // 상품캐러셀 순서 관련
      carouselImages: [],      // 캐러셀(P) 이미지 - 화면 표시/정렬용
      carouselDirty: false,    // 순서 변경 후 미저장 여부
      isSavingOrder: false,    // 순서저장 중복클릭 방지

      // QuillEditor관련
      filename: "productDetail.md",
      content: "",
      editorOption: {
        placeholder: '내용을 입력해주세요...',
        modules: {
          toolbar: 
          {
            container: [
              ['bold','italic','underline','strike'],
              ['blockquote','code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1,2,3,4,5,6,false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link','image','video'],
              [{ 'imageLink': [] }], // 커스텀 툴 추가 (아래에서 핸들러 연결)
            ],
            handlers: {
              imageLink: function() {       //arrow function 사용금지(바인딩이 깨짐)
                // this는 quill 인스턴스!
                const range = this.quill.getSelection();
                if (range) 
                {
                  const [leaf] = this.quill.getLeaf(range.index);
                  if (leaf && leaf.domNode.tagName === 'IMG') 
                  {
                    const url = window.prompt('이미지에 하이퍼링크(URL)을 입력하세요:');
                    if (url) 
                    {
                      const imgNode = leaf.domNode;
                      const parent = imgNode.parentNode;
                      if (parent.tagName !== 'A') 
                      {
                        const linkNode = document.createElement('a');
                        linkNode.setAttribute('href', url);
                        linkNode.setAttribute('target', '_blank');
                        parent.replaceChild(linkNode, imgNode);
                        linkNode.appendChild(imgNode);
                      } 
                      else 
                      {
                        parent.setAttribute('href', url);
                      }
                    }
                  }
                }
              }
            }
          },
          imageResize: {                        // ⭐ 반드시 추가!
            parchment: window.Quill
              ? window.Quill.import('parchment')
              : undefined,
            modules: ['Resize', 'DisplaySize', 'Toolbar']  // 필요하다면 Toolbar 포함
          }
        },

        formats: [
          'bold','italic','underline','strike','blockquote','code-block','header','list',
          'script','indent','direction','size','color','background','font','link','image','video',
          'align', 'float', 'width', 'height'
        ]
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },

  created() {
    // path에서 사용된 productId
    this.productId = this.$route.query.productId;

    //결합상품?
    if(this.productId.substring(0,3)==="MX-") {
      this.pdtFlag = "MIX";
    }
    this.getProductInfo();

    // this.getProductDetail();
    this.getProductImage();
    this.getProductDetailImage(); // 제품상세이미지호출
    // this.getProductB2BPrice();
  },
  
  mounted() {
    console.log("handler:",this.user.handlerId);
    // 로그인한 사람이 아니라면 메인화면으로
    if(this.user.handlerGrade > 9) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 권한이 없습니다.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    document.getElementById("user").style.display = "none";
  },

  methods: {
    // 상품캐러셀 순서 관련
    // sort 기준 정렬 (sort 없는 이미지는 맨 뒤)
    sortImages(list) {
      const toNum = (v) => (v === null || v === undefined || v === '') ? Number.MAX_SAFE_INTEGER : Number(v);
      return [...list].sort((a, b) => toNum(a.sort) - toNum(b.sort));
    },

    async getProductImage() {
      const res = await this.$api("/api/imageList_new", {param: [this.productId]});
      this.productImage = Array.isArray(res) ? res : [];
      this.carouselImages = this.sortImages(this.productImage.filter(c => c.catImg === 'P'));
      this.carouselDirty = false;
    },

    // 캐러셀 순서이동 (dir: -1 앞으로, 1 뒤로)
    moveCarousel(idx, dir) {
      const target = idx + dir;
      if (target < 0 || target >= this.carouselImages.length) return;

      const list = [...this.carouselImages];
      [list[idx], list[target]] = [list[target], list[idx]];
      this.carouselImages = list;
      this.carouselDirty = true;
    },

    // 캐러셀 순서저장: 현재 화면 순서대로 1 ~ n 재부여
    async saveCarouselOrder() {
      if (this.isSavingOrder || !this.carouselDirty) return;
      this.isSavingOrder = true;

      const failed = [];
      try {
        for (let i = 0; i < this.carouselImages.length; i++) {
          const m = this.carouselImages[i];
          const res = await this.$api("/api/locateImage", {param: [
            i + 1, m.pdtCode, 'P', m.imgName, "0"
          ]});
          // $api는 에러 시 throw하지 않으므로 반환값으로 판정
          if (!res || res.error) failed.push(m.imgName);
        }

        if (failed.length > 0) {
          console.error('[캐러셀 순서저장 실패]', failed);
          this.$swal.fire('', `일부 이미지(${failed.length}건)의 순서저장에 실패했습니다.<br>다시 시도해주세요.`, 'warning');
        } else {
          this.$swal.fire('', '캐러셀 순서가 저장되었습니다.', 'success');
        }
      } finally {
        this.isSavingOrder = false;
        this.getProductImage();     // DB 기준으로 다시 표시
      }
    },

    // Quill Editor관련
    onEditorChange({ html }) {
      this.internalContent = html         // 내부 상태만 변경
      this.$emit('update:content', html)  // 부모에 변경 알림
    },
    saveDoc() {
      const html = this.$refs.quillRef?.$el?.querySelector('.ql-editor')?.innerHTML || this.internalContent 
      this.$emit('saveDocument', { content: html })
      // this.$emit('saveDocument', { content: this.internalContent })
    },

    async quillFlagging(flag) {
      this.quillFlag = flag
      console.log("quillFlag:", this.quillFlag);

      // 에디터 모드(Quill)일 때는 style 삭제하지 않음
      if (this.quillFlag !== "Y") {
        document.querySelectorAll('.ql-editor img').forEach(img => img.removeAttribute('style'));
      }

      if(this.quillFlag === "Y") 
      {
        // Quill Editor를 열 때 md파일이 있으면 로드한다
        if(this.productInfo.quillFlag === "Y") 
        {
          try 
          {
            // const response = await axios.get(`/uploads/doc_editor/${this.filename}`);
            let response = await axios.get(`/uploads/${this.productId}/${this.filename}`);
            if (response.data.success) 
            {
              this.content = response.data.content;
            } 
            else 
            {
              throw new Error('Failed to load document');
            }
          } 
          catch (error) 
          {
            this.$swal.fire('', '에디팅된 상세페이지가 없습니다', 'info');
          }
        }
      }
    },

    // Quill Editor결과저장
    async handleSaveDocument(payload) {
      if (!payload.content || payload.content.trim() === '') 
      {
        this.$swal.fire('', '내용을 입력하세요', 'warning');
        return false;
      }
      try 
      {
        // let response = await this.$api(`/uploads/doc_editor/`, { content: payload.content, filename: this.filename });
        let response = await this.$api(`/uploads/${this.productId}/`, { content: payload.content, filename: this.filename });
        if (response.success === true) 
        {
          let resUpdate = await this.$api("/api/updatePdtDetailEditFlag", {param: [ this.quillFlag, this.productId]});
          if(resUpdate.affectedRows > 0) 
          {
            this.$swal.fire('', '상품 상세페이지가 저장되었습니다.', 'success');
          }
        } 
        else 
        {
          this.$swal.fire('', '상품 상세페이지가 저장 중 오류가 발생했습니다.', 'warning');
        }
      } 
      catch (error) 
      {
        this.$swal.fire('', '문서 저장 중 오류가 발생했습니다.', 'error');
      }
    },

    async getProductInfo() {
      let productInfo = {};
      if(this.pdtFlag === "MIX") {
        productInfo = await this.$api("/api/pdtInfo_mix", {param: [this.productId]});
      }
      else {
        productInfo = await this.$api("/api/pdtInfo", {param: [this.productId]});
      }

      if(productInfo.length > 0) 
      {
        this.productInfo = productInfo[0]
      }
      console.log("pInfo:", this.productInfo);
    },

    // async getProductDetail() {
    //   // axios공통모듈을 호출하여 app.js를 타고 sql.js를 타고 데이타호출, 상품코드도 파라메타로 넘김
    //   let productDetail = await this.$api("/api/productDetail", {param: [this.productId]});
    //   // 상세정보가 있다면 첫번째값 하나만 가져온다
    //   if(productDetail.length > 0) {
    //     this.productDetail = productDetail[0]
    //   }
    //   console.log("pDetail:", this.productDetail);
    // },

    // async getProductImage() {
    //   this.productImage = await this.$api("/api/imageList_new", {param: [this.productId]});
    // },

    async getProductDetailImage() {
      this.productDetailImage = await this.$api("/api/productDetailImage_new", {param: [this.productId]});
    },

    //이미지 표시순서지정
    // locationImage(m.pdtCode, 'D', m.imgName)
    async locateImage(sort, pdtCode, catImg, imgName) {
            let useFlag = "0"
      let locateImgPosition = await this.$api("/api/locateImage", {param: [
        sort, pdtCode, catImg, imgName, useFlag
      ]})

      if(locateImgPosition.affectedRows > 0)
      {
        this.$swal.fire("", "순서가 지정되었습니다", "success")
        .then(async() => {
          let resUpdate = await this.$api("/api/updatePdtDetailEditFlag", {param: [ this.quillFlag, this.productId]});
          if(resUpdate.affectedRows > 0) 
          {
            this.getProductImage()
          }
        })
      }
      else 
      {
        this.$swal.fire("", "순서지정이 되지 않습니다. 관리자에게 문의해 주세요", "warning")
        return false
      }
    },

    deleteImage(pdtCode, catImg, imgName) {
      console.log(`id:${pdtCode}, catImg:${catImg}`);
      this.$swal.fire({
        html: '이미지를 삭제하시겠습니까?',
        icon: "question",
        showCancelButton: true,
        confirmButtonText: `삭제`,
        cancelButtonText: `취소`
      }).then(async (result) => {
        if (result.isConfirmed) {
          let flag = "pdtImage"
          await this.$api("/api/imageDelete",{param:[pdtCode, catImg, imgName]});      //이미지 데이타 기록삭제
          await this.$api("/api/deletePhoto", {param: pdtCode, imgName, flag})         //이미지 물리적 삭제

          let resUpdate = await this.$api("/api/updatePdtDetailEditFlag", {param: [ this.quillFlag, this.productId]});
          if(resUpdate.affectedRows > 0) 
          {
            this.getProductImage()
          }          
          // this.getProductImage();
          this.$swal.fire('삭제완료', '', 'success');
        } 
      });
    },

    sealingImage(pdtCode, catImg, imgName) {
      console.log(`id:${pdtCode}, catImg:${catImg}, imgName:${imgName}`);
      this.$swal.fire({
        title: '확인: 미사용?',
        showCancelButton: true,
        confirmButtonText: `처리`,
        cancelButtonText: `취소`
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$api("/api/imageSealing",{param:['admin', pdtCode, catImg, imgName]});
          let resUpdate = await this.$api("/api/updatePdtDetailEditFlag", {param: [ this.quillFlag, this.productId]});
          if(resUpdate.affectedRows > 0) 
          {
            this.getProductImage()
          }          
          //this.getProductImage();
          this.$swal.fire('미사용 처리', '', 'success');
        } 
      });
    },

    async uploadFile(files, catImg, useFlag) {
      let imgName = "";
      let data = null;
      if (files) {
        imgName = files[0].name;
        data = await this.$base64(files[0]);
      }
      // console.log("files:",files, "name:",imgName, "catImg:",catImg, "pdtCode:",this.productId);
      const { error } = await this.$api(`/upload/${this.productId}/${catImg}/${imgName}/${useFlag}`, { data });
      if (error) 
      {
        return this.$swal("업로드 오류발생, 재시도 필요.");
      }
      else 
      {
        let resUpdate = await this.$api("/api/updatePdtDetailEditFlag", {param: [ this.quillFlag, this.productId]});
          if(resUpdate.affectedRows > 0) 
          {
            this.$swal("업로드 완료");
          }        
      }
      setTimeout(() => {
        this.getProductImage();
      }, 1000);
    },

    goToList() {
      if(this.pdtFlag === 'MIX') {
        this.$router.push({path: '/salesMix'});
      }
      else {
        this.$router.push({path: '/sales'});
      }
    }
  }
}
</script>

<style scoped>
  label {
    font-weight: bold;
    font-size: 1.1rem;
  }

  .carousel-order-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    background: #f1f5ff;
    border: 1px solid #d6e0f5;
    border-radius: 6px;
    padding: 6px 10px;
    margin-bottom: 8px;
  }
  .carousel-order-guide { font-size: 0.82rem; color: #4a5a7a; }

  .carousel-order-badge {
    position: absolute;
    top: 8px;
    left: 8px;
    background: rgba(28, 28, 28, 0.75);
    color: #fff;
    font-size: 0.85rem;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 14px;
  }
  .carousel-order-badge.first { background: #86cd53; }

  .carousel-move-group {
    position: absolute;
    bottom: 8px;
    left: 8px;
    display: flex;
    gap: 4px;
  }
  .carousel-move-group .btn { box-shadow: 0 1px 4px rgba(0,0,0,0.25); }  

/* Quill 이미지 정렬 보정 */
/*
.ql-editor .ql-align-center img {
  display: block;
  margin: 0 auto;
}

.ql-editor .ql-align-right img {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

.ql-editor .ql-align-left img {
  display: block;
  margin-right: auto;
  margin-left: 0;
}
*/

</style>

<style>
/* App.vue 또는 main.css 등 글로벌 스타일 파일에 아래 추가 */
.ql-editor .ql-align-right { text-align: right !important; }
.ql-editor .ql-align-center { text-align: center !important; }
.ql-editor .ql-align-left { text-align: left !important; }
.ql-editor .ql-align-justify { text-align: justify !important; }

.ql-editor .ql-align-right img,
.ql-editor .ql-align-center img,
.ql-editor .ql-align-left img {
  display: block !important;
}

.ql-editor .ql-align-right img { margin-left: auto !important; margin-right: 0 !important; }
.ql-editor .ql-align-center img { margin-left: auto !important; margin-right: auto !important; }
.ql-editor .ql-align-left img { margin-left: 0 !important; margin-right: auto !important; }
</style>